'use strict';

/**
 * @ngdoc directive
 * @name prepApp.directive:navigation
 * @description
 * # navigation
 */
angular.module('prepApp')
    .directive('navigation', function (BasicService, routeNavigation, $log, CONFIG) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'views/directives/navigation.html',
            controller: function ($scope) {
                $scope.routes = routeNavigation.routes;
                $scope.activeRoute = routeNavigation.activeRoute;
                $scope.adminURL = CONFIG.backendURL + 'admin/';

                /*
                var logoutUser = function () {
                    removeCredentials();
                    applyLogin(false);
                };
                */

                var applyLogin = function (good) {
                    var loginAs = BasicService.document[0].getElementById('login-show');
                    var login = BasicService.document[0].getElementById('login-form');
                    if (good) {
                        loginAs.style.display = 'block';
                        login.style.display = 'none';
                    } else {
                        loginAs.style.display = 'none';
                        login.style.display = 'block';
                    }
                };

                if (BasicService.cookies.get('djangotoken')) {
                    BasicService.http.defaults.headers.common.Authorization = 'Token ' + BasicService.cookies.get('djangotoken');
                    $scope.username = BasicService.cookies.get('djangouser');
                    applyLogin(true);
                } else {
                    applyLogin(false);
                }

                $scope.$on('event:auth-loginRequired', function () {
                    applyLogin(false);
                });

                $scope.$on('event:auth-forbidden', function () {
                    applyLogin(false);
                    $log.log('redirect to login');
                });

                $scope.$on('event:auth-loginCancelled', function () {
                    applyLogin(false);
                });

                $scope.$on('event:auth-loginConfirmed', function (event, data) {
                    BasicService.cookies.put('djangotoken', data.token);
                    BasicService.cookies.put('djangouser', data.username);
                    $scope.username = BasicService.cookies.get('djangouser');
                    BasicService.http.defaults.headers.common.Authorization = 'Token ' + data.token;
                    applyLogin(true);
                });
            }
        };
    });
